module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-green-current.c2630967.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-green-current.png
// module id = 3228
// module chunks = 11